import { NAME } from './constants';
import { menu } from './menu';
import { router } from './router';

export const WmsModule = {
	name: NAME,
	menu,
	router,
};
